export class WorkorderValidator {
  static validate(workorderData: any, t: any): string[] {
    const validationErrors: string[] = [];

    if (!workorderData.customer) {
      validationErrors.push(t("common:customer"));
    }

    if (!workorderData.contacts?.length) {
      validationErrors.push(t("common:contacts"));
    }

    if (!workorderData.address) {
      validationErrors.push(t("common:address"));
    }

    return validationErrors;
  }
}
